/**
 * 利润报表配置
 * 打印数据构建函数
 */

import moment from 'moment'
import { getLoginName } from '@/utils/util'

export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 利润报表无传统表格数据，dataSource 为 handlePrint() 中构建的 printItems
  const rows = (dataSource || []).map((item, idx) => ({
    rowIndex: item.rowIndex,
    item: item.item || '',
    amount: item.amount || ''
  }))

  return {
    // 单据主体 — 字段名与 hiprint-register.js PROFIT_REPORT.headerGroup 绑定
    reportTitle: '利润报表',
    reportDate: moment().format('YYYY-MM-DD'),
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    creatorName: getLoginName(),
    profit: (queryParam && queryParam.profit) ? '￥' + Number(queryParam.profit).toFixed(2) : '￥0.00',
    incomeTotal: (queryParam && queryParam.incomeTotal) ? '￥' + Number(queryParam.incomeTotal).toFixed(2) : '￥0.00',
    paymentTotal: (queryParam && queryParam.paymentTotal) ? '￥' + Number(queryParam.paymentTotal).toFixed(2) : '￥0.00',
    // 单据明细 — 字段名 table 与模板表格元素绑定
    table: rows,
    // 公司信息
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}